import axios from './axios';
import language from "./language";
export default async (phone_area_code: string, phone: string, google_recaptcha_token: string) => {
    return await axios.post('/user/forgot', {
        phone_area_code,
        phone,
        lang: language(),
        google_recaptcha_token
    });
};
